export default __webpack_public_path__ + "static/media/Pom.76ec1745.png";